<template>
  <Modal v-if="showOptionModal" @close="close()" :class="{ fontLoaded }">
    <template v-slot:body>
      <div class="text-block" v-linkified>
        <span>
          {{optionActionText}}
        </span>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal';
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  name: 'OptionActionModal',
  components: {
    Modal
  },
  computed: {
    ...mapState('poll', [
      'showOptionModal',
      'optionActionText',
      'fontLoaded'
    ])
  },
  methods: {
    ...mapMutations('poll', [
      'setOptionActionText'
    ]),
    close() {
      this.setOptionActionText('');
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  background-color: white;
  border-radius: 8px;
  color: black;
  width: 350px;
  height: 220px;
}
.text-block {
  display: flex;
  justify-content: center;
}
.checkmark-block {
  display: flex;
  justify-content: center;

  .checkmark {
    width: 72px;
    height: 72px;
  }
}
</style>
